export const customerPortal = {
  title: 'Customer Portal',
  subtitle: 'Self-service portal for customers',
  
  // Tabs
  tabs: {
    overview: 'Overview',
    projects: 'Projects',
    submissions: 'Submissions',
    missingItems: 'Missing Items',
    documents: 'Documents'
  },
  
  // Overview
  overview: {
    welcome: 'Welcome',
    noData: 'No data to display',
    activeProjects: 'Active Projects',
    submittedRequests: 'Submitted Requests',
    missingDocuments: 'Missing Documents',
    closedProjects: 'Closed Projects'
  },
  
  // Projects
  projects: {
    title: 'Ongoing Projects',
    noProjects: 'No ongoing projects',
    description: 'Your ongoing projects will appear here'
  },
  
  // Submissions
  submissions: {
    title: 'Submissions',
    availableForms: 'Available Forms - Submit New Request',
    mySubmissions: 'My Submissions',
    noSubmissions: 'No submissions',
    description: 'Your submissions and their status will appear here',
    noForms: 'No forms available',
    noFormsDescription: 'There are currently no published forms',
    clickToFill: 'Click to fill out',
    status: {
      draft: 'Draft',
      pending: 'Pending',
      submitted: 'Submitted',
      processing: 'Processing',
      completed: 'Completed',
      approved: 'Approved',
      rejected: 'Rejected',
      hibernated: 'Hibernated'
    },
    submittedAt: 'Submitted',
    notes: 'Notes',
    viewDetails: 'View Details',
    details: 'Submission Details',
    formName: 'Form Name',
    submissionDate: 'Submission Date',
    submittedData: 'Submitted Data',
    close: 'Close'
  },
  
  // Missing Items
  missingItems: {
    title: 'Missing Items',
    warning: 'Warning',
    warningMessage: 'Please note that according to our records, you have missing documents (documents that have not been submitted for accounting). Missing documents prevent the completion of accounting services, which may result in reporting obligations to the NAV Anti-Money Laundering Office. Please submit the missing documents immediately and indicate the submission in the system. Thank you for your cooperation!',
    noItems: 'No missing items',
    description: 'There are currently no missing items',
    acknowledge: 'Acknowledge',
    markAsUploaded: 'Mark as Uploaded',
    uploadFiles: 'Upload Files',
    status: {
      pending: 'Pending',
      acknowledged: 'Acknowledged',
      uploaded: 'Uploaded',
      approved: 'Approved'
    },
    category: {
      invoice: 'Invoice',
      receipt: 'Receipt',
      contract: 'Contract',
      document: 'Document',
      other: 'Other'
    },
    priority: {
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      urgent: 'Urgent'
    },
    dueDate: 'Due Date',
    createdAt: 'Created'
  },
  
  // Documents
  documents: {
    title: 'Documents',
    noDocuments: 'No documents',
    description: 'Your documents will appear here'
  }
};
